import { Dialog } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChromePicker } from 'react-color';

const ColorPicker = ({ onChange, currentColor, handleClose, open, theme }) => {
  const [selectedColor, setSelectedColor] = useState(currentColor);
  console.log('close', handleClose);
  useEffect(() => {
    setSelectedColor(currentColor);
  }, [currentColor]);

  const handleChange = (color) => {
    setSelectedColor(color.hex);
    onChange(color.hex);
  };

  const handleSave = (e) => {
    e.stopPropagation();
    console.log('Cor salva:', selectedColor);
    onChange(selectedColor);
    handleClose();
  };

  const handleClosePicker = (e) => {
    e?.stopPropagation();
    handleClose();
  };

  return (
    <Dialog
      onClose={handleClosePicker}
      aria-labelledby="color-picker-dialog"
      open={open}
      maxWidth="xs"
    >
      <div
        style={{
          padding: 16,
          backgroundColor: theme?.palette?.background?.default || '#f5f5f5',
          borderRadius: 8,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ width: '100%' }}>
          <ChromePicker
            color={selectedColor}
            onChange={handleChange}
            disableAlpha={false}
            styles={{
              default: {
                picker: {
                  boxShadow: 'none',
                  borderRadius: '4px',
                },
              },
            }}
          />
        </div>
        <div style={{ marginTop: 16, display: 'flex', gap: '10px' }}>
          <button
            onClick={handleSave}
            style={{
              padding: '10px 20px',
              border: 'none',
              backgroundColor: theme?.palette?.primary?.main || '#4caf50',
              color: '#ffffff',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}
          >
            Aplicar
          </button>
          <button
            onClick={handleClosePicker}
            style={{
              padding: '10px 20px',
              border: 'none',
              backgroundColor: '#f44336',
              color: '#ffffff',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ColorPicker;